import {toast} from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export const toastSuccess = async (messages, position = "top-center") => {
    let message_html = getMessageHtml(messages);

    let message_duration = getMessageDuration(message_html);

    toast(message_html, {
        containerClassName: "ts-toast",
        autoClose: message_duration,
        type: "success",
        position: position,
        dangerouslyHTMLString: true,
    });
}

export const toastErrors = async (errors: unknown, position = "top-center") => {
    let message_html = getMessageHtml(errors);

    let message_duration = getMessageDuration(message_html);

    toast(message_html, {
        containerClassName: "ts-toast",
        autoClose: message_duration,
        type: "error",
        position,
        dangerouslyHTMLString: true,
    }); // ToastOptions
    trackError("toast", `${message_html}`);
}

export const getMessageHtml = (messages) => {
    let i = 1;
    let list_html = "";

    if (Object.keys(messages).length > 1) {
        for (let k in messages) {
            list_html += i + ") " + messages[k] + "<br/>";
            i++;
        }
    } else {
        if (messages[0]) {
            list_html += messages[0];
        }
    }

    return list_html;
}

export const getMessageDuration = (message_html) => {
    let duration = 3000;

    let chars = message_html.length;
    let readable = 10; // readable character per second.

    duration = duration * (chars / readable);

    return duration;
}
